module.exports = __webpack_public_path__ + "img/97.4e2ce36b.png";